import styled from "styled-components";
import PlaceItem from "./PlaceItem";
import TextGothic from "components/utils/TextGothic";
import { PlacelistType } from "resources/placelists";
import { colorCode } from "resources/colors";
import { media } from "utils/media";

type Props = {
  placelist: PlacelistType;
};

const Placelist = (props: Props) => {
  const { placelist } = props;

  return (
    <Wrapper>
      <Index>
        <Center size="20px" forwardedAs="h3">
          目次
        </Center>
        {placelist.places.map((place, i) => (
          <a href={`#place${i + 1}`} key={`index_${i}`}>
            <IndexPlace size="14px" lh={1} weight="normal">
              {place.name}
            </IndexPlace>
          </a>
        ))}
      </Index>
      <PlacelistWrapper>
        {placelist.places.map((place, i) => (
          <PlaceItem
            key={`place_${i}`}
            placelist={placelist}
            place={place}
            placeIndex={i}
          />
        ))}
        <Caption size="14px" lh={1} weight="noraml">
          Photos by 小川哲汰朗
        </Caption>
      </PlacelistWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.section``;

const Index = styled.section`
  ${media.sp`
    padding: 48px 20px;
  `}
  ${media.pc`
    box-sizing: border-box;
    padding: 48px 123.5px;
    width: 715px;
    margin: 0 auto;
  `}
`;

const PlacelistWrapper = styled.div`
  padding: 48px 0 80px;
  ${media.pc`
    width: 715px;
    margin: 0 auto;
  `}
`;

const Center = styled(TextGothic)`
  text-align: center;
`;

const IndexPlace = styled(TextGothic)`
  margin-top: 24px;
  color: ${colorCode.gray};
  text-decoration: underline;
  &:hover {
    color: black;
  }
`;

const Caption = styled(TextGothic)`
  color: ${colorCode.gray};
  padding: 0 20px;
  text-align: right;
`;

export default Placelist;
